// assets/refunds.js
// FHL GO — Refund Policy page behaviour (i18n + reveal + anchor offset)

(function () {
  console.log("[refunds.js] loaded");

  const I18N = {
    en: {
      toggleLabel: "EN | ES",

      // Header / breadcrumb label used by header-fhl-country
      crumbHome: "Home",
      crumbRefunds: "Refund Policy",

      // Hero
      refundsLabel: "Refund Policy",
      refundsTitle: "Refund Policy",
      refundsIntro:
        "Our approach to refunds, returns, and making things right.",

      // TOC
      toc_eligibility: "1. Eligibility",
      toc_process: "2. How to Request a Refund",
      toc_exclusions: "3. Exclusions & Limitations",
      toc_methods: "4. Refund Methods & Timing",
      toc_contact: "5. Contact",

      // Body text
      ctLead: "Questions about a refund? Email",

      elig_p1:
        "Refunds are considered when a paid service was not delivered as described or when a clear error occurred on our side.",
      elig_p2:
        "Requests must be submitted within a reasonable time after the issue occurs and include enough detail for our team to review what happened.",

      proc_p1:
        "To request a refund, contact our support team and include your full name, order or shipment reference, and a brief description of the issue.",
      proc_p2:
        "Our team will review your request and may ask for additional documentation such as receipts, photos, or delivery confirmations to complete the evaluation.",
      proc_p3:
        "We aim to respond to refund requests within 3–5 business days, depending on volume and the complexity of the case.",

      excl_p1:
        "Some services may be non-refundable where costs have already been incurred on your behalf, such as customs duties, government fees, or completed third-party services.",
      excl_p2:
        "Refunds are not provided for issues outside our reasonable control, including customs decisions, regulatory inspections, or situations resulting from incorrect information provided by the customer.",

      meth_p1:
        "Approved refunds are generally issued to the original payment method used for the transaction, unless a different arrangement is agreed with you in writing.",
      meth_p2:
        "Once processed, it may take several business days for the refund to appear on your account depending on your bank or payment provider.",
      meth_p3:
        "In some cases, we may offer a credit toward future services instead of a direct refund, where appropriate and agreed with you.",

      // Footer / legal nav
      followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
  },

    es: {
      toggleLabel: "ES | EN",

      crumbHome: "Inicio",
      crumbRefunds: "Política de reembolsos",

      refundsLabel: "Política de reembolsos",
      refundsTitle: "Política de reembolsos",
      refundsIntro:
        "Nuestro enfoque para reembolsos, devoluciones y soluciones justas.",

      toc_eligibility: "1. Elegibilidad",
      toc_process: "2. Cómo solicitar un reembolso",
      toc_exclusions: "3. Exclusiones y límites",
      toc_methods: "4. Formas y tiempos de reembolso",
      toc_contact: "5. Contacto",

      ctLead: "¿Dudas sobre un reembolso? Escribe a",

      elig_p1:
        "Los reembolsos se consideran cuando un servicio pagado no se prestó como se describió o cuando hubo un error claro de nuestra parte.",
      elig_p2:
        "Las solicitudes deben enviarse dentro de un plazo razonable después del problema e incluir suficiente detalle para que nuestro equipo pueda revisarlo.",

      proc_p1:
        "Para solicitar un reembolso, contacta a nuestro equipo de soporte e incluye tu nombre completo, referencia del envío o pedido y una breve descripción del inconveniente.",
      proc_p2:
        "Nuestro equipo revisará tu solicitud y puede pedir documentación adicional, como recibos, fotos o comprobantes de entrega, para completar la evaluación.",
      proc_p3:
        "Nuestro objetivo es responder a las solicitudes de reembolso en un plazo de 3 a 5 días hábiles, según el volumen y la complejidad del caso.",

      excl_p1:
        "Algunos servicios pueden no ser reembolsables cuando ya se hayan incurrido costos a tu nombre, como aranceles, tasas gubernamentales o servicios de terceros ya completados.",
      excl_p2:
        "No se otorgan reembolsos por situaciones fuera de nuestro control razonable, incluidas decisiones de aduana, inspecciones regulatorias o casos derivados de información incorrecta proporcionada por el cliente.",

      meth_p1:
        "Los reembolsos aprobados generalmente se emiten al mismo método de pago utilizado en la transacción, salvo que se acuerde por escrito otra opción contigo.",
      meth_p2:
        "Una vez procesado, el reembolso puede tardar varios días hábiles en verse reflejado según tu banco o proveedor de pago.",
      meth_p3:
        "En algunos casos, podemos ofrecer un crédito para servicios futuros en lugar de un reembolso directo, cuando sea apropiado y acordado contigo.",

      followTitle: "SÍGUENOS",
    companyTitle: "COMPAÑÍA",
    legalTitle: "INFO LEGAL",
    lnkAbout: "Quiénes somos",
    lnkServices: "Servicios",
    lnkBlog: "Blog",
    lnkTerms: "Términos del servicio",
    lnkPrivacy: "Política de privacidad",
    lnkRefunds: "Política de reembolsos",
    copyright: "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
  
    },
  };

  function applyLang(lang) {
    const dict = I18N[lang] || I18N.en;
    console.log("[refunds.js] applyLang:", lang);

    // Plain text nodes
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.dataset.i18n;
      if (!key) return;
      if (dict[key] !== undefined) el.textContent = dict[key];
    });

    // HTML-enabled nodes (none right now, but wired for future)
    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.dataset.i18nHtml;
      if (!key) return;
      if (dict[key] !== undefined) el.innerHTML = dict[key];
    });

    // Language toggle pill (same selector spray as services/terms/privacy)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle && dict.toggleLabel) toggle.textContent = dict.toggleLabel;

    // Document title
    document.title =
      lang === "es"
        ? "FHL GO — Política de reembolsos"
        : "FHL GO — Refund Policy";

    // Persist shared language key
    try {
      localStorage.setItem("fhl_lang", lang);
    } catch (e) {}

    // Notify header/logo listeners
    try {
      const ev = new CustomEvent("fhlgo:lang-switch", { detail: { lang } });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("[refunds.js] DOMContentLoaded");

    // Initial language (shared with all the other pages)
    const saved = (() => {
      try {
        return localStorage.getItem("fhl_lang") || "en";
      } catch (e) {
        return "en";
      }
    })();
    applyLang(saved);

    // Hook up toggle button
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle) {
      console.log("[refunds.js] toggle found →", toggle);
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        let current = "en";
        try {
          current = localStorage.getItem("fhl_lang") || "en";
        } catch (err) {}
        const next = current === "en" ? "es" : "en";
        console.log("[refunds.js] toggle click →", next);
        applyLang(next);
      });
    } else {
      console.warn("[refunds.js] No language toggle found on this page");
    }

    // React if some other script fires fhlgo:lang-switch
    document.addEventListener("fhlgo:lang-switch", function (e) {
      const lang = (e && e.detail && e.detail.lang) || "en";
      console.log("[refunds.js] external fhlgo:lang-switch →", lang);
      applyLang(lang);
    });

    // Reveal-on-scroll scoped to refunds page
    if (
      !(
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
    ) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const ent of entries) {
            if (ent.isIntersecting) {
              ent.target.classList.add("is-visible");
              io.unobserve(ent.target);
            }
          }
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );

      const nodes =
        document.querySelectorAll(".refunds-page [data-reveal]") ||
        document.querySelectorAll("[data-reveal]");

      nodes.forEach((el) => io.observe(el));
    }

    // Anchor offset so anchors clear sticky header
    const header =
      document.querySelector(".fhlgo-country-header") ||
      document.querySelector(".site-header");
    const setOffset = () => {
      const h = header ? header.offsetHeight : 96;
      document.documentElement.style.setProperty(
        "--anchor-offset",
        h + 12 + "px"
      );
    };
    setOffset();
    window.addEventListener("resize", setOffset);
    window.addEventListener("load", setOffset);
  });
})();
